import React from 'react';
import Select from '../Select/Select';
import { CLIENT_CONTACT_PERSON_TYPES } from '../../constants';

const SelectContactType = ({ ...props }) => {
  return <Select options={CLIENT_CONTACT_PERSON_TYPES} label={'Тип контактного лица'} placeholder={'Выберите из списка'} {...props} />;
};

export default SelectContactType;
